import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AHeader from "./Admin/AHeader";
import Afooter from "./Main/Afooter";


const AdminLayout = () => {
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // if no logged user, redirect to login
    const lu = JSON.parse(localStorage.getItem('loggedUser') || 'null');
    if (!lu) {
      navigate('/Select-login');
      return;
    }
    setAuthChecked(true);

    // auto-logout: check expiry every 30s
    const id = setInterval(() => {
      const cur = JSON.parse(localStorage.getItem('loggedUser') || 'null');
      if (!cur) { clearInterval(id); navigate('/Select-login'); return; }
      if (cur.expiry && Date.now() > cur.expiry) {
        localStorage.removeItem('loggedUser');
        clearInterval(id);
        alert('Session expired. Logged out.');
        navigate('/Select-login');
      }
    }, 30000);

    // refresh expiry on any user activity inside admin area
    const bump = () => {
      const cur = JSON.parse(localStorage.getItem('loggedUser') || 'null');
      if (cur) { cur.expiry = Date.now() + 20 * 60 * 1000; localStorage.setItem('loggedUser', JSON.stringify(cur)); }
    };
    window.addEventListener('click', bump);
    window.addEventListener('keydown', bump);

    return () => { clearInterval(id); window.removeEventListener('click', bump); window.removeEventListener('keydown', bump); };
  }, [navigate]);

  if (!authChecked) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AHeader/>

      <main className="flex-grow-1" style={{ 
        flex: 1, 
        background: "linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 50%, #F3F4F6 100%)",
        backdropFilter: "blur(10px)",
        minHeight: "calc(100vh - 130px)"
      }}>
        <div className="container-fluid px-3 px-lg-4 py-4">
          <Outlet />
        </div>
      </main>

      <Afooter/>

      <style>{`
        body {
          font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        
        main {
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
          position: relative;
        }
        
        main::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="0.5" fill="%23000" opacity="0.02"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          pointer-events: none;
        }
        
        .card {
          border: none;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(13, 148, 136, 0.08);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }
        
        .card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 12px 40px rgba(13, 148, 136, 0.15);
        }
        
        .btn {
          border-radius: 12px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 600;
          letter-spacing: 0.5px;
        }
        
        .btn-primary {
          background: linear-gradient(135deg, #213F6D 0%, #193264 100%);
          border: none;
          box-shadow: 0 4px 15px rgba(33, 63, 109, 0.3);
        }
        
        .btn-primary:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 8px 25px rgba(13, 148, 136, 0.4);
          background: linear-gradient(135deg, #0B7A6F 0%, #084C42 100%);
        }
        
        .btn-secondary {
          background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
          border: none;
        }
        
        .btn-success {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          border: none;
        }
        
        .btn-warning {
          background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
          border: none;
        }
        
        .btn-danger {
          background: linear-gradient(135deg, #dc3545 0%, #e83e8c 100%);
          border: none;
        }
        
        .table {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }
        
        .table thead {
          background: linear-gradient(135deg, #213F6D 0%, #193264 100%);
          color: white;
        }
        
        .table tbody tr {
          transition: all 0.2s ease;
        }
        
        .table tbody tr:hover {
          background-color: rgba(13, 148, 136, 0.05);
          transform: scale(1.01);
        }
        
        .form-control, .form-select {
          border-radius: 10px;
          border: 2px solid rgba(13, 148, 136, 0.2);
          transition: all 0.3s ease;
          background-color: #FFFFFF;
          color: #1E293B;
        }
        
        .form-control::placeholder {
          color: #94A3B8;
          opacity: 0.7;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #213F6D;
          box-shadow: 0 0 0 0.2rem rgba(33, 63, 109, 0.25);
          color: #1E293B;
          background-color: #FFFFFF;
        }
        
        .modal-content {
          border-radius: 20px;
          backdrop-filter: blur(20px);
        }
        
        .navbar {
          backdrop-filter: blur(15px);
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .card {
          animation: fadeInUp 0.6s ease-out;
        }
        
        .alert {
          border-radius: 12px;
          border: none;
        }
        
        .badge {
          border-radius: 8px;
          font-weight: 600;
        }
        
        .progress {
          border-radius: 10px;
          height: 8px;
        }
        
        .list-group-item {
          border-radius: 10px !important;
          margin-bottom: 5px;
          border: 1px solid rgba(13, 148, 136, 0.15) !important;
          background-color: #FFFFFF;
          color: #1E293B;
        }
        
        .list-group-item.active {
          background-color: #213F6D !important;
          border-color: #213F6D !important;
          color: #FFFFFF;
        }
        
        .dropdown-menu {
          border-radius: 12px;
          border: none;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }
        
        .nav-link {
          border-radius: 10px;
        }
        
        @media (max-width: 768px) {
          .container-fluid {
            padding-left: 15px;
            padding-right: 15px;
          }
          
          .card {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminLayout;
